import { defineSseEvent } from '@terra/shared-sse-contracts';
import { z } from 'zod';

export const ReportGenerationStatusSchema = z.union([
  z.literal('PENDING'),
  z.literal('CREATING_NEXT_STEPS'),
  z.literal('EDITING'),
  z.literal('REVIEWING'),
  z.literal('PUBLISHING'),
  z.literal('COMPLETED'),
  z.literal('FAILED'),
]);

export const ReportGenerationSsePayloadSchema = z.object({
  jobId: z.string(),
  status: ReportGenerationStatusSchema,
  progress: z.number(),
  message: z.string(),
  reportId: z.string().optional(),
  error: z.string().optional(),
});

export const REPORT_GENERATION_SSE_EVENT = defineSseEvent({
  type: 'report-generation',
  payload: ReportGenerationSsePayloadSchema,
  channelPrefix: 'report-generation',
  channelKey: ({ jobId }) => jobId,
});

export type ReportGenerationSsePayload = z.infer<
  typeof ReportGenerationSsePayloadSchema
>;
export type ReportGenerationStatus = z.infer<
  typeof ReportGenerationStatusSchema
>;
